export const brandConfig = {
  name: "New Beginnings Events",
  whatsappLink: "https://wa.me/919677390867",
  phone: "+91 96773 90867",
  phoneRaw: "919677390867",
  email: "bookings@newbeginningsevents.in",
  address: "63rd St, Sidco Nagar, Villivakkam, Chennai, Tamil Nadu 600049",
  logo: "/assets/home/logo_new.png",
};

export const homeMedia = {
  aboutFrameOverlay: "/assets/home/about_frame_overlay.png",
  aboutFrameInside: "/assets/home/about_frame_inside.jpg",
  aboutFinal: "/assets/home/about_final.webp",
  videoMaskOverlay: "/assets/home/video_mask.png",
  videoInside: "/assets/home/video_inside.mp4",
};

export const externalLinks = {
  googleReviews:
    "https://www.google.com/search?q=new+beginnings+events&oq=new+beginnings+events&gs_lcrp=EgZjaHJvbWUqDggAEEUYJxg7GIAEGIoFMg4IABBFGCcYOxiABBiKBTINCAEQABiDARixAxiABDINCAIQABiDARixAxiABDIHCAMQABiABDIKCAQQLhixAxiABDIGCAUQRRg8MgYIBhBFGDwyBggHEEUYPNIBCDIxMDNqMGo3qAIAsAIA&sourceid=chrome&ie=UTF-8",
};

export const socialLinks = [
  { label: "Instagram", href: "https://www.instagram.com/_newbeginningsevents_/" },
  { label: "YouTube", href: "https://www.youtube.com/@Newbeginningsevents" },
  { label: "Facebook", href: "https://www.facebook.com/profile.php?id=61580788463795" },
  { label: "WhatsApp", href: "https://wa.me/919677390867" },
];

export const homeCarouselSlides = [
  { image: "/assets/home/carousel_latest_1.webp", couple: "" },
  { image: "/assets/home/carousel_latest_2.webp", couple: "" },
  { image: "/assets/home/carousel_latest_3.webp", couple: "" },
  { image: "/assets/home/carousel_latest_4.webp", couple: "" },
  { image: "/assets/home/carousel_latest_5.webp", couple: "" },
];

export const portfolioEvents = {
  weddings: [
    {
      id: "meera-aarav-heritage",
      title: "Meera & Aarav",
      subtitle: "The Heritage Palace Edit",
      cover: "/assets/wedding-1.webp",
      story:
        "A heritage-inspired celebration layered with candlelit corridors, royal florals, and a meticulously timed ceremony flow that brought intimacy to grandeur.",
      testimonial: "Every transition felt effortless and cinematic. It was beyond everything we imagined.",
      gallery: ["/assets/wedding-1.webp", "/assets/wedding-2.webp", "/assets/wedding-3.webp"],
    },
    {
      id: "kavya-rishi-timeless",
      title: "Kavya & Rishi",
      subtitle: "Timeless Evenings",
      cover: "/assets/wedding-2.webp",
      story:
        "A velvet-and-gold visual language framed this evening wedding, where elevated hospitality and elegant staging created a deeply immersive guest experience.",
      gallery: ["/assets/wedding-2.webp", "/assets/wedding-4.webp", "/assets/wedding-5.webp"],
    },
    {
      id: "naina-viraj-grand",
      title: "Naina & Viraj",
      subtitle: "The Grand Chapter",
      cover: "/assets/wedding-4.webp",
      story:
        "From baraat choreography to reception reveal, every sequence was orchestrated with precision, allowing the celebration to feel seamless and deeply personal.",
      gallery: ["/assets/wedding-4.webp", "/assets/wedding-1.webp", "/assets/wedding-6.webp"],
    },
    {
      id: "tara-dev-regalia",
      title: "Tara & Dev",
      subtitle: "Regalia in Motion",
      cover: "/assets/wedding-6.webp",
      story:
        "An editorial-meets-traditional wedding with expressive decor scenes, curated lighting cues, and elevated hospitality experiences through every function.",
      gallery: ["/assets/wedding-6.webp", "/assets/wedding-2.webp", "/assets/wedding-3.webp"],
    },
  ],
  corporate: [
    {
      id: "summit-2026",
      title: "Leadership Summit 2026",
      subtitle: "Corporate Events",
      cover: "/assets/corporate-1.webp",
      story:
        "Executive-level conference management with stage sequencing, hospitality protocols, and real-time show-calling for uninterrupted delivery.",
      gallery: ["/assets/corporate-1.webp", "/assets/corporate-3.webp", "/assets/corporate-4.webp"],
    },
    {
      id: "award-gala",
      title: "Annual Awards Gala",
      subtitle: "Corporate Events",
      cover: "/assets/corporate-3.webp",
      story:
        "A high-impact award evening designed for premium brand recall with structured transitions and precision cueing.",
      gallery: ["/assets/corporate-3.webp", "/assets/corporate-2.webp", "/assets/corporate-4.webp"],
    },
  ],
  "sfx-entries": [
    {
      id: "signature-entries",
      title: "Signature Couple Entries",
      subtitle: "SFX & Entries",
      cover: "/assets/sfx-1.webp",
      story:
        "Cold pyros, timed lighting bursts, and cinematic walk-in sequences built to create unforgettable first moments.",
      gallery: ["/assets/sfx-1.webp", "/assets/sfx-2.webp", "/assets/sfx-4.webp"],
    },
    {
      id: "immersive-stage",
      title: "Immersive Stage Concepts",
      subtitle: "SFX & Entries",
      cover: "/assets/sfx-2.webp",
      story:
        "Visual effects designed to elevate stage narratives with choreography-led reveal moments.",
      gallery: ["/assets/sfx-2.webp", "/assets/sfx-3.webp", "/assets/sfx-4.webp"],
    },
  ],
};

export const coupleReviews = [
  {
    name: "Meera & Aarav",
    text: "The team delivered with unmatched clarity and luxury. Every detail felt intentional.",
  },
  {
    name: "Kavya & Rishi",
    text: "We felt looked after from day one. The execution was elegant, calm, and world-class.",
  },
  {
    name: "Tara & Dev",
    text: "Our guests still speak about the atmosphere and choreography. Pure finesse.",
  },
];

export const blogPosts = [
  {
    slug: "designing-a-regal-wedding-experience",
    title: "Designing a Regal Wedding Experience",
    teaser: "How structure, lighting, and emotional pacing shape unforgettable wedding journeys.",
    cover: "/assets/blog-1.webp",
    vision:
      "To design a wedding atmosphere that feels grand yet intimate, where every scene reflects the couple's personality.",
    concept:
      "A maroon-and-gold visual story anchored in velvet textures, warm candle palettes, and layered staging.",
    execution:
      "From vendor orchestration to cue-based transitions, each function was mapped down to minute-level sequencing.",
    experience:
      "Guests moved through beautifully timed moments, each zone unfolding like a curated chapter.",
    gallery: ["/assets/blog-1.webp", "/assets/wedding-3.webp", "/assets/wedding-5.webp"],
  },
  {
    slug: "the-art-of-seamless-celebration-flow",
    title: "The Art of Seamless Celebration Flow",
    teaser: "Inside our framework for making large-format celebrations feel graceful and effortless.",
    cover: "/assets/blog-2.webp",
    vision: "To remove stress from celebration logistics and replace it with confidence and delight.",
    concept: "A layered guest journey combining hospitality touchpoints, flow logic, and elevated visuals.",
    execution:
      "Back-of-house command systems, real-time coordination, and integrated vendor communication.",
    experience: "A polished celebration where everything feels natural, smooth, and emotionally resonant.",
    gallery: ["/assets/blog-2.webp", "/assets/corporate-1.webp", "/assets/catering-1.webp"],
  },
  {
    slug: "luxury-details-that-create-legacy",
    title: "Luxury Details That Create Legacy",
    teaser: "The subtle decisions behind events that stay in memory for years.",
    cover: "/assets/blog-3.webp",
    vision: "To elevate each detail into a meaningful design decision.",
    concept: "Textural palettes, elevated tablescapes, and immersive entrance moments.",
    execution: "Precision vendor briefs, styling checklists, and production-first timelines.",
    experience: "An event that feels deeply personal while maintaining couture-level standards.",
    gallery: ["/assets/blog-3.webp", "/assets/sfx-1.webp", "/assets/wedding-6.webp"],
  },
];

export const corporateService = {
  slides: ["/assets/corporate-1.webp", "/assets/corporate-3.webp", "/assets/corporate-4.webp"],
  showcase: [
    { title: "Fashion Shows", image: "/assets/corporate-2.webp" },
    { title: "School / College Events", image: "/assets/corporate-4.webp" },
    { title: "Large-Scale MNC Events", image: "/assets/corporate-1.webp" },
    { title: "Awards Functions", image: "/assets/corporate-3.webp" },
  ],
};

export const cateringService = {
  slides: ["/assets/catering/catering_hero_new.webp", "/assets/catering-2.webp", "/assets/catering-3.webp"],
  veg: {
    title: "Vegetarian Culinary Curation",
    image: "/assets/catering/catering_veg_new.webp",
    text: "Seasonal ingredients, plated elegance, and regional authenticity presented with modern finesse.",
  },
  nonVeg: {
    title: "Non-Veg Signature Experiences",
    image: "/assets/catering/catering_nonveg_new.webp",
    text: "Chef-led menus blending rich flavors and premium presentation for immersive dining journeys.",
  },
};

export const sfxService = {
  slides: ["/assets/sfx-1.webp", "/assets/sfx-2.webp", "/assets/sfx-4.webp"],
  showcases: [
    { title: "Cold Pyros", image: "/assets/sfx-2.webp" },
    { title: "LED Walkways", image: "/assets/sfx-1.webp" },
    { title: "Fog Effects", image: "/assets/sfx-4.webp" },
    { title: "Bride & Groom Entries", image: "/assets/sfx-1.webp" },
    { title: "Stage Concepts", image: "/assets/sfx-2.webp" },
    { title: "Custom Installations", image: "/assets/sfx-3.webp" },
  ],
};